// src/layouts/ProtectedLayout.tsx
import React from 'react';
import AppNavbar from '../presentation/components/navbar.component';


interface ProtectedLayoutProps {
    onLogout: () => void;
    children: React.ReactNode;
}

const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ children, onLogout }) => {
    return (
        <>
            <AppNavbar onLogout={onLogout} />
            <div className="container">{children}</div>
        </>
    );
};

export default ProtectedLayout;